import React, { useState, useEffect, useRef } from "react";
import { Form, Input, Button, Card, Typography, message, Row, Col } from "antd";
import {
  EnvironmentOutlined,
  MailOutlined,
  MessageOutlined,
  SendOutlined,
  PhoneOutlined,
  GlobalOutlined,
} from "@ant-design/icons";
import { useParams } from "react-router-dom";
import Footer from "./Components/Footer";

const apiHost = process.env.REACT_APP_FHOST;
const apiPort = process.env.REACT_APP_FPORT;
const { Title, Text } = Typography;
const { TextArea } = Input;

function Contactus() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const validateEmail = (_, value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!value) {
      return Promise.reject(new Error("Please enter your email address"));
    }
    if (!emailRegex.test(value)) {
      return Promise.reject(new Error("Please enter a valid email address"));
    }
    return Promise.resolve();
  };

  const validateMessage = (_, value) => {
    if (!value) {
      return Promise.reject(new Error("Please enter your message"));
    }
    if (value.length < 10) {
      return Promise.reject(
        new Error("Message must be at least 10 characters long")
      );
    }
    if (value.length > 1000) {
      return Promise.reject(
        new Error("Message must not exceed 1000 characters")
      );
    }
    return Promise.resolve();
  };

  const handleSubmit = async (values) => {
    setLoading(true);

    try {
      const response = await fetch(`${apiHost}${apiPort}/sendMail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email_id: values.email_id,
          message: values.message,
        }),
      });

      const result = await response.json();

      if (response.ok) {
        message.success(
          "Thank you for your message! We will get back to you soon."
        );
        form.resetFields();
      } else {
        message.error(
          result.error || "Something went wrong. Please try again."
        );
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      message.error(
        "Network error. Please check your connection and try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* style={{boxShadow:" rgb(210, 227, 255) 0px 0px 37px 12px " }} */}
      <div className="min-h-screen  from-blue-50 to-indigo-100 py-12 px-4">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-8">
            <Title level={1} className="text-gray-800 mb-4">
              Contact Us
            </Title>
            <Text className="text-gray-600 text-lg">
              We'd love to hear from you. Send us a message and we'll respond as
              soon as possible.
            </Text>
          </div>

          <Card
            className="shadow-xl border-0 rounded-2xl"
            bodyStyle={{ padding: "2rem" }}
          >
            <Form
              form={form}
              layout="vertical"
              onFinish={handleSubmit}
              size="large"
              requiredMark={false}
            >
              <Form.Item
                name="email_id"
                label={
                  <span className="text-gray-700 font-medium">
                    <MailOutlined className="mr-2" />
                    Email Address
                  </span>
                }
                rules={[{ validator: validateEmail }]}
              >
                <Input
                  placeholder="Enter your email address"
                  className="rounded-lg border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                  size="large"
                />
              </Form.Item>

              <Form.Item
                name="message"
                label={
                  <span className="text-gray-700 font-medium">
                    <MessageOutlined className="mr-2" />
                    Message
                  </span>
                }
                rules={[{ validator: validateMessage }]}
              >
                <TextArea
                  placeholder="Enter your message here..."
                  rows={6}
                  className="rounded-lg border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                  showCount
                  maxLength={1000}
                />
              </Form.Item>

              <Form.Item className="mb-0">
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  icon={<SendOutlined />}
                  className="w-full h-12 bg-blue-600 hover:bg-blue-700 border-0 rounded-lg font-medium text-lg shadow-lg hover:shadow-xl transition-all duration-300"
                >
                  {loading ? "Sending..." : "Send Message"}
                </Button>
              </Form.Item>
            </Form>
          </Card>

          <div className="mt-8 text-center">
            <Text className="text-gray-500">
              Need immediate assistance? Email us at{" "}
              <a
                href="mailto:support@example.com"
                className="text-blue-600 hover:text-blue-800"
              >
                support@skyraconverter.com
              </a>
            </Text>
          </div>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-4 py-16">
        <Card className="shadow-lg text-center">
          <Title level={2} className="mb-6 text-gray-800">
            Contact Us
          </Title>

          <Row gutter={[32, 16]} justify="center">
            <Col xs={24} md={8}>
              <div className="flex items-start justify-center space-x-2 ">
                <EnvironmentOutlined className="text-blue-500 mt-1" />
                <Text className="text-gray-600 text-left">
                  Skyraan Technologies, No.17, Sri Venkateshwara Towers, FCI Rd,
                  opp. Fire Station, Gandhimaa Nagar, Peelamedu, Coimbatore,
                  Tamil Nadu 641004
                </Text>
              </div>
            </Col>
            <Col xs={24} md={8}>
              <div className="flex items-center justify-center space-x-2">
                <PhoneOutlined className="text-blue-500" />
                <Text className="text-gray-600">+91 97918 82387</Text>
              </div>
            </Col>
            <Col xs={24} md={8}>
              <div className="flex items-center justify-center space-x-2">
                <GlobalOutlined className="text-blue-500" />
                <Text className="text-gray-600 ">www.skyraan.com</Text>
              </div>
            </Col>
          </Row>
        </Card>
      </div>
      <Footer />
    </div>
  );
}

export default Contactus;
